import {
  ChangeDetectorRef,
  Component,
  ViewEncapsulation,
  Input,
} from "@angular/core";

@Component({
  selector: "lowy-modal",
  templateUrl: "./modal.component.html",
  styleUrls: ["./modal.component.scss"],
  encapsulation: ViewEncapsulation.None, // we want our modal styles to persist to other components which use them
})
export class ModalComponent {
  @Input("tall") tall: boolean;

  visible: boolean;
  isOpen: boolean;

  constructor(private cdr: ChangeDetectorRef) {}

  public open() {
    this.visible = true;
    setTimeout(() => {
      this.isOpen = true;
    });
  }

  public close(e?) {
    if (e && e.target && (e.target.className || e.target.innerHTML)) {
      // special case for do not close on clickOutside for mat-dropdown
      if (e.target.className.includes("mat-option-text")) {
        return;
      }
      // special case for do not close on clickOutside for mat-dropdown
      else if (e.target.className.includes("cdk-overlay-backdrop")) {
        return;
      }
      // special case for do not close on clickOutside for add tag inside dropdown
      else if (e.target.innerHTML === "add Tag") {
        return;
      }
      // special case for do not close on clickOutside for delete tag in editTag modal
      else if (
        e.target.className.includes("material-icons") &&
        e.target.innerHTML === "cancel"
      ) {
        return;
      } else if (e.target.className.includes("mat-calendar")) {
        return;
      }
      // special case for lowy-dropdown in upload modal
      else if (
        e.target.className.includes("ng-star-inserted") &&
        e.target.innerHTML.includes("add")
      ) {
        return;
      }
      // special case for lowy-dropdown in upload modal
      else if (e.target.className.includes("dropdown-li")) {
        return;
      } else if (e.target.className.includes("mat-button-wrapper")) {
        return;
      }
    }

    if (this.isOpen) {
      this.isOpen = false;
      setTimeout(() => {
        this.visible = false;
        // Happens outside expected component lifecycle (to facilitate animation timing), add detectChanges call
        this.cdr.detectChanges();
      }, 500);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/modal.component.ts